import API from './apiConfig';

export const getActiveCourse = async () => {
  try {
    const response = await API.get(`/courses/active?_=${Date.now()}`);
    return response;
  } catch (error) {
    console.error(`Error fetching active course`, error);
    throw error;
  }
};

export const getCourses = async () => {
  try {
    const response = await API.get(`/courses?_=${Date.now()}`);
    return response.data.data;
  } catch (error) {
    console.error(`Error fetching active course`, error);
    throw error;
  }
};

export const getAjahn = async (courseId) => {
  try {
    const response = await API.get(`/ajahn/${courseId}?_=${Date.now()}`);
    return response.data.data;
  } catch (error) {
    console.error(`Error fetching ajahns`, error);
    throw error;
  }
};

export const getActiveCourseAjahn = async () => {
  try {
    const response = await API.get(`/ajahn?_=${Date.now()}`);
    return response.data.data;
  } catch (error) {
    console.error(`Error fetching active course ajahns`, error);
    throw error;
  }
};